// services/rolservice.js
import baseURL from "../url";

/* ======================
   LISTAR ROLES
====================== */
export const getRoles = async () => {
  try {
    const res = await fetch(`${baseURL}?url=rolapi`, {
      method: "GET",
    });
    const data = await res.json();
    return data.data; // [{idrol, rol}]
  } catch (error) {
    console.error(error);
    return null;
  }
};

/* ======================
   GUARDAR / EDITAR ROL
====================== */
export const saveRol = async (rolData) => {
  try {
    const res = await fetch(`${baseURL}?url=rolapi&action=guardar`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rolData),
    });

    return await res.json();
  } catch (error) {
    console.error(error);
    return { res: 0, mensaje: "Error de conexión" };
  }
};

/* ======================
   ELIMINAR ROL
====================== */
export const deleteRol = async (idrol) => {
  try {
    const res = await fetch(`${baseURL}?url=rolapi&action=eliminar`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idrol }),
    });

    return await res.json();
  } catch (error) {
    console.error(error);
    return { res: 0, mensaje: "Error de conexión" };
  }
};
